import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  margin-top: 50%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  > span {
    font-size: 1.5rem;
    font-weight: 500;
    margin-left: 10px;
  }
`;

export const Body = styled.div`
  padding: 30px 0px 10px 0px;
  font-size: 1.2rem;
  color: rgba(0, 0, 0, 0.8);
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
